var _g, _mask, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.9999 40C79.9999 62.0907 62.0919 80 39.9999 80C17.9093 80 0 62.0907 0 40C0 17.908 17.9093 0 39.9999 0C62.0919 0 79.9999 17.908 79.9999 40Z",
    fill: "#00AEC7"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_1209_30933",
    maskUnits: "userSpaceOnUse",
    x: 20.666,
    y: 17.6431,
    width: 35,
    height: 44,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 20.666,
    y: 17.6431,
    width: 35,
    height: 44
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3046 42.3697V56.3484C53.3046 58.1684 51.8313 59.6431 50.01 59.6431H25.9593C24.1407 59.6431 22.666 58.1684 22.666 56.3484V23.6511C22.666 21.8311 24.1407 20.3564 25.9593 20.3564H50.01C51.8313 20.3564 53.3046 21.8311 53.3046 23.6511V32.6817"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.3046 42.3697C51.3046 41.2652 52.2001 40.3697 53.3046 40.3697C54.4092 40.3697 55.3046 41.2652 55.3046 42.3697H51.3046ZM50.01 20.3564V22.3564V20.3564ZM55.3046 32.6817C55.3046 33.7863 54.4092 34.6817 53.3046 34.6817C52.2001 34.6817 51.3046 33.7863 51.3046 32.6817H55.3046ZM55.3046 42.3697V56.3484H51.3046V42.3697H55.3046ZM55.3046 56.3484C55.3046 59.2724 52.9364 61.6431 50.01 61.6431V57.6431C50.7262 57.6431 51.3046 57.0644 51.3046 56.3484H55.3046ZM50.01 61.6431H25.9593V57.6431H50.01V61.6431ZM25.9593 61.6431C23.0356 61.6431 20.666 59.2724 20.666 56.3484H24.666C24.666 57.0644 25.2458 57.6431 25.9593 57.6431V61.6431ZM20.666 56.3484V23.6511H24.666V56.3484H20.666ZM20.666 23.6511C20.666 20.727 23.0356 18.3564 25.9593 18.3564V22.3564C25.2458 22.3564 24.666 22.9351 24.666 23.6511H20.666ZM25.9593 18.3564H50.01V22.3564H25.9593V18.3564ZM50.01 18.3564C52.9364 18.3564 55.3046 20.727 55.3046 23.6511H51.3046C51.3046 22.9351 50.7262 22.3564 50.01 22.3564V18.3564ZM55.3046 23.6511V32.6817H51.3046V23.6511H55.3046Z",
    fill: "white",
    mask: "url(#path-2-outside-1_1209_30933)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.166 30.729H46.8113H29.166Z",
    fill: "#00AEC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.166 30.729H46.8113",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.166 36.9097H45.2407H29.166Z",
    fill: "#00AEC7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.166 36.9097H45.2407",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.166 43.0903H39.854H29.166Z",
    fill: "#00AEC7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.166 43.0903H39.854",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.166 49.271H37.9887H29.166Z",
    fill: "#00AEC7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.166 49.271H37.9887",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0605 49.271L47.7939 47.2483L64.4672 30.5737C65.6258 29.415 65.6258 27.5377 64.4672 26.379C63.3098 25.2203 61.4299 25.2203 60.2725 26.379L43.6712 43.0897L42.0605 49.271Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.dc3c5c3bfa71afbeb245017e32ec587a.svg";
export { ForwardRef as ReactComponent };